import { useEffect, useState } from "react";
import * as lodash from "lodash";
import CentralizedModalContainer from "../../../../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Icon,
  Modal
} from "@theorgchartdev/storybook";
import {
  DataSourceButton,
  GetSourceLabel
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSourceButton";
import { appstr } from "@coreapp/utils/appstr";

import { ADPSetupComposite } from "./ADPSetupComposite";
import { WorkdaySetupComposite } from "./WorkdaySetupComposite";
import { DayforceSetupComposite } from "./DayforceSetupComposite";
import { BambooHRSetupComposite } from "./BambooHRSetupComposite";
import { FileBrowseComposite } from "./FileBrowseComposite";
import { AppendTableSetupComposite } from "./AppendTableSetupComposite";
import { SalesforceSetupComposite } from "./SalesforceSetupComposite";
import { OracleSetupComposite } from "./OracleSetupComposite";
import { NamelySetupComposite } from "./NamelySetupComposite";
import { LeverSetupComposite } from "./LeverSetupComposite";
import { GreenhouseSetupComposite } from "./GreenhouseSetupComposite";
import { JobviteSetupComposite } from "./JobviteSetupComposite";
import { ICIMSSetupComposite } from "./iCIMSSetupComposite";
import { SuccessFactorsSetupComposite } from "./SuccessFactorsSetupComposite";
import { AzureADSetupComposite } from "./AzureADSetupComposite";
import { OCAPISetupComposite } from "./OCAPISetupComposite";
import { OrangeHRMSetupComposite } from "./OrangeHRMSetupComposite";
import { TriNetSetupComposite } from "./TriNetSetupComposite";
import { PeopleHRSetupComposite } from "./PeopleHRSetupComposite";
import { BreatheHRSetupComposite } from "./BreatheHRSetupComposite";
import { UKGProSetupComposite } from "./UKGProSetupComposite";
import { UKGProRaasSetupComposite } from "./UKGProRaasSetupComposite";
import { UKGReadySetupComposite } from "./UKGReadySetupComposite";
import { PaychexSetupComposite } from "./PaychexSetupComposite";
import { PaycorSetupComposite } from "./PaycorSetupComposite";
import { PaySpaceSetupComposite } from "./PaySpaceSetupComposite";
import { RipplingSetupComposite } from "./RipplingSetupComposite";
import { ThriveTRMSetupComposite } from "./ThriveTRMSetupComposite";
import { PaylocitySetupComposite } from "./PaylocitySetupComposite";
import { ISolvedSetupComposite } from "./iSolvedSetupComposite";
import { JeminiSetupComposite } from "./JeminiSetupComposite";
import { AreCredsFilled } from "../DataSetupInputComposite";
import { AuthValidationComposite } from "../AuthValidationComposite";
import {
  kConnectorAllowAuthValidation,
  DATA_SOURCES_TEST_PREFIX,
  ShowDatasetTypeOptions
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { PositionOptionsComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/PositionOptionsComposite";
import { CornerstoneSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/CornerstoneSetupComposite";
import { SAPXMLSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/SAPXMLSetupComposite";
import { SAPTXTSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/SAPTXTSetupComposite";
import { SAPRFCSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/SAPRFCSetupComposite";
import { WorkdayAPISetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/WorkdayAPISetupComposite";
import { OPPSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/OPPSetupComposite";
import { SageSetupComposite } from "./SageSetupComposite";
import { Sage300ZASetupComposite } from "./Sage300ZASetupComposite";
import { SignifySetupComposite } from "./SignifySetupComposite";
import { PaycomSetupComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/PaycomSetupComposite";

export const DataSourceConfigurationModal = ({
  chartConfig,
  config,
  handleUpdate,
  resetIntegration,
  idx,
  type,
  show,
  onClose
}) => {
  const [configClone, setConfigClone] = useState(() => lodash.cloneDeep(config));

  useEffect(() => {
    let configCopy = lodash.cloneDeep(config);
    setConfigClone(configCopy);
  }, [config]);

  const save = () => {
    handleUpdate(configClone, idx);
    //setEditMode(false);
  };
  const cancel = () => {
    let configCopy = lodash.cloneDeep(config);
    setConfigClone(configCopy);
    onClose();
  };

  const handleConfigUpdate = updatedObj => {
    let configCopy = configClone;
    configCopy = { ...configCopy, ...updatedObj };
    setConfigClone(configCopy);
  };

  const GetDataSourceControls = (configClone, sourceIndex) => {
    let content = null;

    switch (configClone["source"]) {
      case "ADP":
      case "ADP Lifion":
      case "Vantage":
      case "ADP NG HCM":
      case "WFN Next Generation":
      case "ADP Enterprise":
      case "ADP Canada":
      case "ADP Europe":
      case "ADP Detail":
      case "ADP Recruitment":
      case "ADP WFN CA Recruitment Module":
      case "ADP Recruit Management":
        content = (
          <ADPSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Append Plan":
      case "Append Table":
        content = (
          <AppendTableSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "AzureAD":
        content = (
          <AzureADSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Bamboo":
        content = (
          <BambooHRSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "BreatheHR":
        content = (
          <BreatheHRSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Cornerstone":
        content = (
          <CornerstoneSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Dayforce":
        content = (
          <DayforceSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            resetIntegration={resetIntegration}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "CSV":
      case "XLS":
        let fileName = configClone["datafile"];
        let directory = configClone["datadir"];
        content = (
          <FileBrowseComposite
            file={fileName}
            directory={directory}
            includeBrowse
            onChange={handleConfigUpdate}
            config={configClone}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "SAP XML":
        content = (
          <SAPXMLSetupComposite
            includeBrowse
            onChange={handleConfigUpdate}
            config={configClone}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "SAP":
        content = (
          <SAPTXTSetupComposite
            includeBrowse
            onChange={handleConfigUpdate}
            config={configClone}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "SAP RFC":
        content = (
          <SAPRFCSetupComposite
            includeBrowse
            onChange={handleConfigUpdate}
            config={configClone}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Greenhouse":
        content = (
          <GreenhouseSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "ICIMS":
        content = (
          <ICIMSSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Jobvite":
        content = (
          <JobviteSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Lever":
        content = (
          <LeverSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Namely":
        content = (
          <NamelySetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "ocAPI":
        content = (
          <OCAPISetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "OPP":
        content = (
          <OPPSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Oracle":
        content = (
          <OracleSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "OrangeHRM":
        content = (
          <OrangeHRMSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Paychex":
        content = (
          <PaychexSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Paycor":
        content = (
          <PaycorSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "PaySpace":
        content = (
          <PaySpaceSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Rippling":
        content = (
          <RipplingSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Paycom":
        content = (
          <PaycomSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "paylocity":
      case "paylocity_nextgen":
        content = (
          <PaylocitySetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "PeopleHR":
        content = (
          <PeopleHRSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Salesforce":
        content = (
          <SalesforceSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "SuccessFactors":
        content = (
          <SuccessFactorsSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Thrive TRM":
        content = (
          <ThriveTRMSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "TriNet":
        content = (
          <TriNetSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      // UKG
      case "Ultipro":
        content = (
          <UKGProRaasSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "UKG":
        content = (
          <UKGProSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "UKG Ready":
        content = (
          <UKGReadySetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Workday":
        content = (
          <WorkdaySetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "WorkdayAPI":
        content = (
          <WorkdayAPISetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "isolved":
        content = (
          <ISolvedSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Jemini":
        content = (
          <JeminiSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Sage":
        content = (
          <SageSetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Sage 300 ZA":
        content = (
          <Sage300ZASetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
      case "Signify":
        content = (
          <SignifySetupComposite
            config={configClone}
            onChange={handleConfigUpdate}
            importType={type}
            chartConfig={chartConfig}
            index={sourceIndex}
          />
        );
        break;
    }
    return content;
  };

  const isSaveDisabled = !!configClone.mergeDupes && !configClone.mergeByField;

  const showDatasetTypeOptions = ShowDatasetTypeOptions(chartConfig, type, configClone.source);

  const sourceLabel = configClone.source ? GetSourceLabel(configClone.source, type) : "";
  return (
    <CentralizedModalContainer show={show}>
      <Modal
        id="example-modal"
        dataTestId={`${DATA_SOURCES_TEST_PREFIX}-modal`}
        show={show}
        minWidth={"medium"}
        maxWidth={"medium"}
        centerScreen={true}
      >
        <DialogTitle
          divider={true}
          onClose={cancel}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-modal-title`}
        >
          <span className={"ocn-explorer-icon-label"}>
            {configClone.source ? (
              <DataSourceButton
                chartConfig={chartConfig}
                dataSource={configClone.source}
                type={type}
                showLabel={false}
                imageOnly
                imageWidth={32}
                imageHeight={32}
                buttonPadding={1}
                buttonWidth={32}
              />
            ) : (
              <Icon size={"medium"} name={"gear"} />
            )}
            {appstr("Configure") + " " + sourceLabel}
          </span>
        </DialogTitle>
        <DialogContent className={"oc-modal-content"}>
          <Flex direction={"column"} gap={"4px"} padding={"8px"}>
            {showDatasetTypeOptions && (
              <PositionOptionsComposite
                config={configClone}
                importType={type}
                index={idx}
                onChange={handleConfigUpdate}
              />
            )}
            {GetDataSourceControls(configClone, idx)}
          </Flex>
        </DialogContent>
        <DialogActions divider={true}>
          <Flex width={"100%"} justifyContent="space-between" padding={"4px"}>
            {kConnectorAllowAuthValidation.includes(configClone["source"]) ? (
              <AuthValidationComposite
                disabled={!AreCredsFilled(configClone)}
                chartConfig={chartConfig}
                credentials={configClone}
                type={type}
              />
            ) : (
              <div />
            )}
            <Flex gap="4px">
              <DialogActions.Tertiary
                data-testid={`${DATA_SOURCES_TEST_PREFIX}-modal-cancel-button`}
                onClick={cancel}
              >
                {appstr("Cancel")}
              </DialogActions.Tertiary>
              <DialogActions.Primary
                data-testid="ocn-data-source-save"
                disabled={isSaveDisabled}
                onClick={save}
              >
                {appstr("Save")}
              </DialogActions.Primary>
            </Flex>
          </Flex>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
